// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"33a46ecf","703":"a79647da"}[chunkId] + ".chunk.js";
};